export const ALL_DELIVERIES = 'all';
